import DashboardAbsensi from "../../../../../components/categories/siakad/lms/dashboards_absensi/HomeHead";
export default function Home() {
  
  return (
    <DashboardAbsensi />
  );
}
